import { cx } from 'class-variance-authority';

export const ScreenSeparator = (props: { className?: string }) => {
  return (
    <div className={cx('flex h-[1px] items-center', props.className)}>
      <div className="absolute left-0 right-0 h-[1px] bg-white-4" />
    </div>
  );
};
